import { ASSETS_ROOT } from "./../AssetsUtils";
import { EXRLoader } from "../../../modules/three/examples/jsm/loaders/EXRLoader";
import { BaseCoreImageLoader } from "./_BaseImageLoader";
export class EXRTextureLoader extends BaseCoreImageLoader {
  constructor(_url, _node) {
    super(_url, _node);
  }
  async _getLoader(options) {
    const loader = new EXRLoader(this.loadingManager);
    if (options.tdataType) {
      loader.setDataType(options.dataType);
    }
    return loader;
  }
}
EXRTextureLoader.PARAM_ENV_DEFAULT = `${ASSETS_ROOT}/textures/piz_compressed.exr`;
